export const MSG_ERRO_PREENCHIMENTO_OBRIGATORIO = 'Preenchimento obrigatório.'
